import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
import SelectClub from "../views/SelectClub.vue";
import Thanks from "../views/Thanks.vue";
import Error from "../views/Error.vue";

Vue.use(VueRouter);

// Kuntokeskus voidaan valita ?kuntokeskus=*queryName*
// Test: http://localhost:8080/?kuntokeskus=klaukkala

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: (to, from, next) => {
      if (to.query.kuntokeskus) {
        store.dispatch("selectClubByQueryName", to.query.kuntokeskus);
        next();
      } else if (!store.getters.hasSelectedClub) {
        next({ name: "Valitse" });
      } else {
        next();
      }
    }
  },
  {
    path: "/valitse",
    name: "Valitse",
    component: SelectClub
  },
  {
    path: "/kiitos",
    name: "Kiitos",
    component: Thanks,
    beforeEnter: (to, from, next) => {
      if (!store.getters.hasSelectedClub) {
        next({ name: "Valitse" });
      } else {
        next();
      }
    }
  },
  {
    path: "/virhe",
    name: "Virhe",
    component: Error,
    beforeEnter: (to, from, next) => {
      if (!store.getters.hasSelectedClub) {
        next({ name: "Valitse" });
      } else {
        next();
      }
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
